export const GET_ALL_PODCASTS = 'GET_ALL_PODCASTS';
export const GET_ALL_TIMELINE_PODCASTS = 'GET_ALL_TIMELINE_PODCASTS';
export const GET_RECENT_PODCASTS = 'GET_RECENT_PODCASTS';
export const CREATE_PODCAST = 'CREATE_PODCAST';
export const UPDATE_PODCAST = 'UPDATE_PODCAST';
export const DELETE_PODCAST = 'DELETE_PODCAST';